import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import PlanPriceCards from "../../PricingPage/PlanPriceCards"
import Features from "../../PricingPage/Features"
import Text from "aldoo-ra/Text"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"

const PlansSection = () => {
  return (
    <div className="w-full flex flex-col items-center px-4">
      <Text 
        id="landing_page_plans_section_title"
        component="h2"
        variant="h1"
        className=""
      />
      <PlanPriceCards card_category="individual" /> 

      {/* CTA Banner */}
      <CMSRender
        contentType="BannerCTA"
        match={{ "content.id": "ComparePlanFeatures" }}
        renderItem={(data, id) => (
          <div className="relative w-full md:max-w-[760px] lg:max-w-[990px] md:h-[154px] flex flex-col md:flex-row items-center justify-between bg-primary_lt rounded-[24px] overflow-hidden px-6 md:px-10 py-6 md:py-0 mt-[70px]">
            <Typography
              variant="body_24"
              className="text-text text-center md:ml-[40px] lg:ml-[48px] xl:ml-[128px] mt-0 mb-4 md:my-0 z-10"
            >
              {data.text}
            </Typography>

            <Button
            variant="secondary_m"
              className="z-10"
            >
              {data.button[0].label}
            </Button>

            <img
              src={data.image}
              alt={data.label}
              className="absolute left-0 h-[154px] w-auto object-contain z-0"
              style={{
                height: '154px',       // Fixed height for the image
                width: 'auto',         // Maintain aspect ratio
                maxHeight: 'none',     // Prevent shrinking
                maxWidth: 'none',      // Prevent shrinking
              }}
            />
          </div>
        )}
      />

      <Features />
    </div>
  )
}

export default PlansSection
